export default __webpack_public_path__ + "static/opdemo2-proven-method-2088eb1cd9e162ca7a2913167ef66950.png";